var render = function render(){var _vm=this,_c=_vm._self._c;return _c('quill-editor',{ref:"myQuillEditor",class:`${_vm.error ? 'err' : ''}`,attrs:{"options":{
		placeholder: 'Escribe aquí el mensaje...',
		modules: {
			toolbar: _vm.toolbarOptions,
		},
	}},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})
}
var staticRenderFns = []

export { render, staticRenderFns }